class ListCollections extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-el="list-collections.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="list-collections.slide"]')
    this.controlPrevEl = this.querySelector(
      '[data-el="list-collections.controlprevious"]'
    )
    this.controlNextEl = this.querySelector(
      '[data-el="list-collections.controlnext"]'
    )
    this.scrollerEl = this.querySelector(
      '[data-el="list-collections.scroller"]'
    )

    if (this.slideEls.length < 2) return

    this.carousel = this.initialiseCarousel()

    this.controlPrevEl.addEventListener('click', this.onNavClick.bind(this))

    this.controlNextEl.addEventListener('click', this.onNavClick.bind(this))
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    return new window.KeenSlider551(this.slidesEl, {
      slides: '.car-Carousel_Slide',
      slidesPerView: 1.33333,
      spacing: 5,
      rubberband: false,
      breakpoints: {
        '(min-width: 600px)': {
          slidesPerView: 2,
          spacing: 5
        }
      },
      created: () => {
        this.slidesEl.classList.remove('car-Carousel_Slides-hidden')
      },
      slideChanged: instance => {
        const maxClicks =
          instance.details().size - instance.details().slidesPerView

        instance.details().relativeSlide === 0
          ? (this.controlPrevEl.disabled = true)
          : (this.controlPrevEl.disabled = false)
        instance.details().relativeSlide >= maxClicks
          ? (this.controlNextEl.disabled = true)
          : (this.controlNextEl.disabled = false)
      },
      move: instance => {
        if (this.scrollerEl) {
          let progressTrack = instance.details().progressTrack
          progressTrack = progressTrack >= 1 ? 0 : progressTrack
          const movementPercentage = progressTrack * 100
          this.scrollerEl.style.setProperty(
            '--movement',
            `${movementPercentage}%`
          )
        }
      }
    })
  }

  onNavClick (event) {
    if (event.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

customElements.define('list-collections', ListCollections)
